export default __webpack_public_path__ + "static/media/linux.6d17a264.png";